import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'

Alpine.plugin(collapse)

window.Alpine = Alpine

// регистрируем alpine-компоненты
import './alpine/index'

Alpine.start()
